import { apiRequest } from "@/queries/api/apiUtils";
import {
  SendMessageResponseSchema,
  ConversationFetchResponseSchema,
  ConversationSummaryResponseSchema,
} from "@/schemas/message";

type FetchArgs = {
  page?: number;
  page_size?: number;
  conversation_type?: "CONVERSATION" | "OFFER" | "PAYMENT";
  with?: string;
};
export async function fetchConversationMessages({
  page = 0,
  page_size = 20,
  conversation_type = "CONVERSATION",
  with: withParam,
}: FetchArgs = {}) {
  const res = await apiRequest("conversation/fetch", {
    method: "POST",
    body: JSON.stringify({
      page,
      page_size,
      conversation_type,
      with: withParam,
    }),
  });
  return ConversationFetchResponseSchema.parse(res);
}

type SendArgs = {
  to: string;
  message: string;
  shift_id?: number;
  assignment_id?: number;
  offer_id?: number;
  conversation_type?: "CONVERSATION" | "OFFER" | "PAYMENT";
};
export async function sendConversationMessage({
  to,
  message,
  shift_id,
  assignment_id,
  offer_id,
  conversation_type = "CONVERSATION",
}: SendArgs) {
  const data = {
    conversation: {
      to,
      message,
      conversation_type,
      shift_id,
      assignment_id,
      offer_id,
    },
  };
  const res = await apiRequest("conversation/send", {
    method: "POST",
    body: JSON.stringify(data),
  });
  return SendMessageResponseSchema.parse(res);
}

type FetchSummaryArgs = {
  page?: number;
  page_size?: number;
  conversation_type?: "CONVERSATION" | "OFFER" | "PAYMENT";
  with?: string;
};
export async function fetchConversationSummary({
  page = 0,
  page_size = 20,
  conversation_type = "CONVERSATION",
  with: withParam,
}: FetchSummaryArgs = {}) {
  const res = await apiRequest("conversation/fetch-summary", {
    method: "POST",
    body: JSON.stringify({
      page,
      page_size,
      conversation_type,
      with: withParam,
    }),
  });
  return ConversationSummaryResponseSchema.parse(res);
}
